import React from 'react';
import { SelectOptionComponentProps } from './types';

export const DefaultOptionComponent: React.FC<SelectOptionComponentProps> = ({ option }) => <>{option.text}</>;
